module.exports = __webpack_public_path__ + "static/media/ic-pause.9a0d94cc.svg";